import React, { useEffect, useRef } from "react";
import { Plus } from "lucide-react";

export const CursorGlow = () => {
  const dot = useRef(null);
  const ring = useRef(null);

  useEffect(() => {
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
    let x = window.innerWidth / 2, y = window.innerHeight / 2, rx = x, ry = y, raf;

    const move = (e) => {
      x = e.clientX; y = e.clientY;
      if (dot.current) dot.current.style.transform = `translate(${x}px, ${y}px) translate(-50%, -50%)`;
    };
    const loop = () => {
      rx += (x - rx) * 0.15; ry += (y - ry) * 0.15;
      if (ring.current) ring.current.style.transform = `translate(${rx}px, ${ry}px) translate(-50%, -50%)`;
      raf = requestAnimationFrame(loop);
    };
    const over = (e) => {
      const active = e.target.closest("a, button, input, textarea, select, [role='button']");
      if (ring.current) {
        ring.current.style.width = active ? "56px" : "34px";
        ring.current.style.height = active ? "56px" : "34px";
        ring.current.style.opacity = active ? "1" : "0.65";
      }
      if (dot.current) dot.current.style.opacity = active ? "1" : "0.9";
    };

    window.addEventListener("mousemove", move, { passive: true });
    window.addEventListener("mouseover", over, { passive: true });
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); window.removeEventListener("mousemove", move); window.removeEventListener("mouseover", over); };
  }, []);

  return (
    <>
      <div
        ref={ring}
        aria-hidden="true"
        className="hidden md:block fixed top-0 left-0 z-[9998] pointer-events-none rounded-full"
        style={{ width: 34, height: 34, border: "1.5px solid rgba(43,182,115,0.75)", boxShadow: "0 0 22px 5px rgba(43,182,115,0.35)", transition: "width .2s ease, height .2s ease, opacity .2s ease" }}
      />
      <div
        ref={dot}
        aria-hidden="true"
        className="hidden md:block fixed top-0 left-0 z-[9999] pointer-events-none text-[#1A75BC]"
        style={{ filter: "drop-shadow(0 0 7px rgba(26,117,188,0.85)) drop-shadow(0 0 14px rgba(43,182,115,0.5))" }}
      >
        <Plus size={22} strokeWidth={3} />
      </div>
    </>
  );
};

export default CursorGlow;
